/** @format */

import { useAsync } from "react-async-hook";

const useFetchJson = (url) => {
  const fetchJson = async (url) =>
    fetch(url, { mode: "cors" })
      .then((response) => response.json())
      .catch((error) => {
        console.error(error);
      });

  const asyncRes = useAsync(fetchJson, [url]);

  // I thought about ...asyncRes, but I'd rather leave my return keys alone, and maybe replace with react-query or something different later.
  return {
    error: asyncRes.error, // Don't return our .reject() above as an error
    data: asyncRes.result,
    forceReload: () => asyncRes.execute(url), // Looks like you have to pass in params here, contrary to docs
    loading: asyncRes.loading,
  };
};

export default useFetchJson;
/*
const useFetchJson = <T = any>(
  url?: string
): {
  data?: T;
  loading: boolean;
  error: any;
  forceReload: () => any;
} => {

  const fetchJson = async (url: string ) =>
       fetch(url, { mode: "cors" })
           .then((response) => response.json())
           .catch((error) => {
             console.error(error);
           });

  const asyncRes = useAsync<T>(fetchJson, [url]);

  // I thought about ...asyncRes, but I'd rather leave my return keys alone, and maybe replace with react-query or something different later.
  return {
    error: asyncRes.error, // Don't return our .reject() above as an error
    data: asyncRes.result,
    forceReload: () => asyncRes.execute(url), // Looks like you have to pass in params here, contrary to docs
    loading: asyncRes.loading,
  };
};

export default useFetchJson;
*/
